/**
 * CB scripts
 * 
 * copy onDocumentReady for any new functions...
 */

/* tslint:disable no-var prefer-const no-bitwise one-variable-per-declaration prefer-for-of */

// import { App } from './scripts/lib/desertland.app';
import { Headroom } from 'headroom.js';

//     // Masonry = require("masonry-layout"), // --> moved to cals.masonry.js
//     // ImagesLoaded = require("imagesloaded"); // --> moved to cals.masonry.js

// console.log("cb required");

// function makeMasonry(sel, itemSel, colWidth){ // --> moved to cals.masonry.js
    //http://masonry.desandro.com/ + http://imagesloaded.desandro.com/
//}

export function makeHeadroom() {
    //log("makeHeadroom");
    
    let headEl = document.querySelector(".headroom");
    // construct an instance of Headroom, passing the element
    let headroom = new Headroom(headEl);
    // initialise
    headroom.init({
        offset: 50,
        tolerance: 20,
        classes: {
            initial: "animated",
            pinned: "slideDown",
            unpinned: "slideUp"
            }
    });
    
    // we're not including the jQuery.headroom, so using the vanilla js version above
            // if ($(".headroom").length || $(".headroom").headroom) {
            //     $(".headroom").headroom({
            //         "offset": 50,
            //         "tolerance": 20,
            //         "classes": {
            //             "initial": "animated",
            //             "pinned": "slideDown",
            //             "unpinned": "slideUp"
            //             }
            //     });
            //     // to destroy
            //     //$("#header").headroom("destroy");       
            // } else {
            //     log("!.headroom");
            // }
          
}


export const onDocumentReady = () => {
    // called when main.js says document is ready
    //log(App);// the App object has the whole app state
    // console.log("boes knows dom.retz");
    // makeHeadroom();
    //makeMasonry();//do it in the view after rendered
};


